export default __webpack_public_path__ + "static/media/C3.472642ad.png";